var _defs, _image, _image2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 257.38,
    y1: 256.83,
    x2: 251.81,
    y2: 397.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2a59be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2957b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2852a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#264a91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#243f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 201.26,
    y1: 239.88,
    x2: 124.19,
    y2: 370.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#9bde26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#87c01d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#67900f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#577708"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 320.09,
    y1: 252.08,
    x2: 324.29,
    y2: 360.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9bde26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#87c01d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#67900f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#577708"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 408.19,
    cy: 139.71,
    r: 28.65,
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.89,139.84c0,4.95-1.52,9.53-4.13,13.33-.14.21-.29.41-.44.61-.03.04-.06.08-.08.11-.12.16-.24.32-.36.47-.03.04-.06.08-.09.12-.16.2-.32.39-.48.59-.12.14-.24.28-.37.42-.09.1-.19.21-.28.31-.28.31-.57.6-.87.89-.09.09-.18.17-.27.26-.08.08-.16.15-.24.22-.17.17-.35.32-.53.47-.04.04-.08.07-.12.11-.38.33-.77.64-1.17.94-.14.1-.28.2-.41.3-.42.3-.84.58-1.28.86-.15.09-.29.18-.44.27-.15.09-.29.17-.44.26-.01,0-.03.01-.04.02-.14.08-.28.15-.41.23-.12.06-.23.12-.35.18-.09.05-.18.09-.27.14-.25.13-.51.25-.77.36-4.24,1.2-8.67,1.76-13.08,1.63-.53-.01-1.05-.04-1.58-.08-.14-.03-.28-.06-.42-.09-.1-.02-.21-.05-.31-.07-.19-.05-.39-.1-.58-.15-.17-.04-.34-.09-.5-.14-.07-.02-.15-.04-.22-.07-.16-.05-.33-.1-.48-.16-.26-.09-.52-.18-.78-.28-.15-.06-.3-.11-.45-.17-.05-.02-.1-.04-.15-.06-.18-.07-.36-.15-.53-.23-.16-.07-.32-.14-.47-.21-.01,0-.02-.01-.04-.02-.1-.05-.2-.09-.29-.14-.11-.05-.22-.1-.33-.16-.21-.11-.43-.22-.64-.33,0,0,0,0,0,0-.64-.34-1.26-.72-1.87-1.12-.2-.13-.4-.27-.6-.41-.59-.42-1.16-.86-1.71-1.34-.04-.04-.09-.08-.13-.11-1.57-1.36-2.95-2.93-4.11-4.67-.53-.78-1.01-1.6-1.43-2.44-1.62-3.2-2.54-6.82-2.54-10.65,0-13.01,10.55-23.56,23.56-23.56s23.56,10.55,23.56,23.56Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.39,148.25c1.38-3.03,7-6.18,9.26-6.67s4.61-.54,6.94-.59c2.21-.05,4.43-.09,6.64-.14,2.34-.05,4.94-.02,6.65,1.31.48.37,4.64,3.99,4.34,4.48-.19.32-4.38-2.55-4.77-2.42-1.52.54-3.03,1.07-4.55,1.61-2.23.79-4.48,1.58-6.86,1.98-2.01.34-4.08.39-6.13.36-1.57-.02-3.16-.1-4.66-.51-1.49-.41-4.99,1.71-5.73.54",
    style: {
      fill: "#673a91"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.03,
    cy: 58.43,
    r: 36.92,
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.79,58.43c0,7.11-2.49,13.63-6.64,18.74-5.46,6.72-13.78,11.01-23.11,11.01s-18.16-4.56-23.59-11.63c-3.86-5.02-6.16-11.31-6.16-18.13,0-16.43,13.32-29.75,29.75-29.75s29.75,13.32,29.75,29.75Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.39,
    cy: 58.43,
    r: 18.46,
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.71,58.43c0,2.43-.61,4.72-1.68,6.72-.24.46-.51.9-.8,1.33,0,0-.01.01-.02.02-.07.11-.15.22-.23.33-.05.07-.11.15-.16.22-.01.01-.02.03-.03.04-.06.08-.12.16-.19.24-.06.08-.13.17-.2.25-.07.08-.13.16-.2.24-.01.01-.02.03-.04.04-.07.08-.14.16-.21.24-.12.13-.24.26-.36.38-.1.1-.19.19-.29.29-.07.07-.15.14-.22.21-.06.06-.12.11-.18.17-.29.26-.59.5-.9.74-.09.07-.18.14-.28.21-.49.35-1,.67-1.54.96-.12.07-.25.13-.37.19-.15.07-.29.15-.44.21-.11.05-.23.1-.34.15-.13.06-.26.11-.39.16-.01,0-.02,0-.03.01-.13.05-.26.1-.39.14-.1.04-.21.07-.31.11-.08.03-.17.06-.25.08-.23.07-.46.14-.69.2-.12.03-.23.06-.35.09-.07.02-.14.03-.21.05-.02,0-.04,0-.05.01-.1.02-.21.04-.32.06-.12.02-.25.04-.37.06-.15.02-.29.05-.44.06-.11.01-.21.03-.32.04-.07,0-.13.01-.2.02-.14.01-.29.02-.43.03-.29.02-.58.02-.87.02-.15,0-.29,0-.44,0-.26,0-.52-.02-.77-.04-.18-.02-.37-.04-.55-.06-.12-.01-.23-.03-.35-.05-.05,0-.11-.02-.16-.02-.1-.01-.2-.03-.3-.05-.1-.02-.21-.04-.31-.06-.09-.02-.18-.04-.27-.06-.05-.01-.1-.02-.15-.03-.1-.02-.2-.05-.3-.07-.17-.04-.34-.09-.51-.14l-.21-.07c-.1-.03-.2-.07-.3-.1-.1-.03-.19-.07-.28-.1-.07-.02-.14-.05-.21-.08-.36-.13-.7-.28-1.04-.45-.12-.06-.25-.12-.37-.18-.09-.05-.19-.1-.28-.15-.95-.51-1.82-1.12-2.63-1.82l-.21-.18c-.06-.05-.11-.1-.16-.15-.28-.26-.54-.53-.8-.81-.07-.07-.13-.14-.19-.21,0,0-.02-.02-.02-.02-.07-.09-.15-.17-.22-.26,0,0-.01-.01-.02-.02-.02-.02-.04-.04-.05-.06-.06-.07-.12-.15-.18-.22h0c-.07-.09-.13-.18-.2-.26-1.8-2.39-2.86-5.37-2.86-8.59,0-7.91,6.41-14.33,14.33-14.33s14.33,6.41,14.33,14.33Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.29,
    cy: 242.74,
    r: 25.62,
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.88,242.74c0,3.88-.98,7.54-2.71,10.73-.31.57-.64,1.13-1,1.67-.92,1.4-1.98,2.68-3.18,3.84-1.34,1.3-2.85,2.44-4.48,3.37-1.85,1.06-3.86,1.87-5.99,2.37-.01,0-.02,0-.03,0-1.67.39-3.41.6-5.2.6-.64,0-1.28-.03-1.9-.08-5.03-.42-9.6-2.49-13.15-5.66-.95-.85-1.83-1.79-2.63-2.79-.08-.09-.15-.19-.22-.28-.28-.37-.56-.75-.82-1.14-.13-.19-.26-.39-.38-.59-.38-.6-.73-1.22-1.06-1.85-1.55-3.06-2.43-6.53-2.43-10.2,0-9.25,5.56-17.2,13.53-20.7h0c2.77-1.22,5.84-1.89,9.06-1.89,2.2,0,4.32.31,6.33.9,9.4,2.74,16.27,11.41,16.27,21.69Z",
    style: {
      fill: "#2a59be"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.97,
    cy: 46.93,
    r: 38.43,
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.16,
    cy: 197.7,
    r: 12.81,
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.05,197.7c0,2.72-1,5.21-2.65,7.12-.1.12-.21.24-.32.35-.07.07-.14.15-.22.22-.11.11-.22.21-.33.32-.03.03-.06.06-.09.09-.12.1-.23.2-.35.3-.13.1-.25.21-.39.3-.02.02-.04.03-.06.04-.09.07-.19.14-.28.2-.02.01-.03.02-.05.03-.08.06-.16.11-.24.16-.53.35-1.1.65-1.69.9-1.05.44-2.19.72-3.38.81h0c-.28.02-.55.03-.83.03-.08,0-.17,0-.25,0h-.02c-1.23-.03-2.42-.27-3.52-.68-.1-.04-.19-.07-.29-.11-.19-.08-.37-.16-.56-.25-.06-.02-.12-.05-.17-.08-.07-.04-.15-.07-.22-.11,0,0-.02-.01-.03-.02-.09-.05-.19-.1-.28-.15-.4-.22-.78-.47-1.15-.75-.16-.12-.32-.25-.47-.37-.12-.1-.24-.2-.35-.31-.07-.06-.13-.12-.2-.18-.04-.04-.09-.09-.13-.13-.07-.07-.15-.14-.21-.22h0c-.12-.13-.24-.25-.35-.39,0,0,0,0,0-.01-1.66-1.91-2.66-4.4-2.66-7.13,0-6.01,4.87-10.88,10.88-10.88s10.88,4.87,10.88,10.88Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.9,
    cy: 245.77,
    r: 35.26,
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.75,245.77c0,6.01-1.72,11.63-4.7,16.37-5.45,8.7-15.13,14.48-26.16,14.48s-21.28-6.14-26.64-15.27c-2.68-4.57-4.22-9.9-4.22-15.58,0-17.04,13.81-30.86,30.86-30.86s30.86,13.81,30.86,30.86Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.39,385.38H53.16c24.95-47.74,66.58-85.4,117.14-105.23,25.39-9.96,53.04-15.43,81.97-15.43,15.75,0,31.11,1.62,45.94,4.71,33.51,6.96,64.28,21.4,90.49,41.49,25.94,19.88,47.42,45.29,62.68,74.47Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.51,372.82c-1.35,4.36-3.36,8.78-6.15,12.55-.15.21-.31.42-.47.62H52.84c.11-.21.21-.42.33-.62.58-1.12,1.18-2.23,1.78-3.34.2-.37.4-.74.61-1.11.61-1.1,1.23-2.2,1.85-3.29.21-.36.42-.73.63-1.09.68-1.17,1.37-2.34,2.07-3.49.38-.62.76-1.24,1.14-1.86.89-1.44,1.8-2.87,2.72-4.28.23-.35.46-.7.69-1.05.2-.3.4-.61.6-.91.26-.39.52-.79.79-1.18.23-.35.47-.69.71-1.04.5-.73,1-1.45,1.51-2.18.21-.31.43-.61.64-.91.24-.34.48-.68.73-1.02.24-.34.49-.68.73-1.02.25-.34.49-.68.74-1.01.12-.16.24-.32.36-.48.25-.34.5-.67.75-1.01.15-.2.29-.4.44-.59.23-.31.47-.62.7-.92.25-.33.5-.67.76-1,.25-.33.51-.66.77-.99.25-.33.51-.66.77-.99l.78-.98c.26-.33.52-.65.78-.98.52-.65,1.05-1.3,1.58-1.94.26-.32.53-.64.8-.96.27-.32.53-.64.8-.96.27-.32.54-.64.81-.96.27-.32.54-.63.81-.95.31-.36.61-.72.93-1.07.24-.27.48-.55.72-.82.27-.31.55-.63.83-.94.28-.31.55-.62.83-.93.28-.31.56-.62.84-.93.28-.31.56-.62.85-.92.28-.31.56-.61.85-.92.28-.31.57-.61.85-.91.29-.3.57-.61.86-.91.29-.3.57-.61.87-.91.58-.6,1.16-1.2,1.74-1.79.29-.3.59-.59.88-.89.29-.29.59-.59.88-.88.57-.56,1.14-1.13,1.71-1.69.02-.02.05-.05.07-.07.58-.57,1.17-1.13,1.76-1.69.32-.3.63-.6.95-.9.61-.57,1.22-1.14,1.83-1.71h0c.61-.56,1.23-1.13,1.85-1.68.33-.29.65-.58.97-.87.92-.82,1.85-1.63,2.79-2.44.63-.55,1.27-1.09,1.91-1.62.96-.81,1.92-1.61,2.9-2.39.26-.22.53-.43.8-.65,2.66-2.14,5.37-4.23,8.12-6.25.3-.22.6-.44.9-.66,1.73-1.26,3.48-2.48,5.24-3.69.31-.21.62-.42.93-.64.38-.26.76-.51,1.15-.77.34-.23.69-.46,1.04-.69.22-.14.44-.29.67-.44.29-.19.59-.38.88-.57.3-.2.6-.39.9-.58,2.76-1.77,5.57-3.48,8.41-5.13.28-.16.56-.33.84-.48.26-.15.51-.29.77-.44.37-.21.74-.42,1.12-.63.23-.13.47-.27.71-.4.26-.15.53-.3.8-.44.99-.55,1.99-1.09,2.99-1.62.31-.17.62-.33.93-.49.55-.29,1.1-.58,1.66-.86.37-.19.75-.39,1.12-.58.66-.34,1.33-.67,2-1,.38-.19.77-.38,1.15-.57.35-.17.7-.34,1.06-.51.42-.2.84-.41,1.26-.6.39-.18.77-.37,1.16-.55.16-.07.31-.15.47-.22.29-.14.58-.27.88-.4,3.06-1.41,6.15-2.74,9.28-4.01.4-.16.8-.32,1.2-.48.4-.16.8-.32,1.2-.48h2.48c10.31,7.13-35.87,45.76-37.15,55.87-.51,4.06,2.48,5.64,5.97,6.57,10.65,2.83,18.57-.63,28.81-3.72,4.43-1.34,9.83-2.47,13.19.71,1.68,1.59,2.41,3.93,2.87,6.2,1.74,8.49.59,18.76-1.97,27.04Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.81,330.34c-5.59,8.29-15.7,12.24-19.44,21.99-1.8,4.71-1.8,9.89-1.78,14.93.03,6.04.06,12.08.09,18.12,0,.21,0,.42,0,.62h-58.23c-.08-.21-.17-.42-.25-.62-.77-1.83-1.69-3.57-2.78-5.31-2.68-4.31-4.76-8.85-7.54-13.1-2.03-3.1-4.12-9.19-.92-12.4,4.04-4.06,12.6-3.74,17.68-5.07,4.07-1.07,8.74-2.35,11.93-5.26,4.8-4.4,6.38-16.97-1.25-19.54-6.8-2.29-14.26,5.16-20.9,2.44-3-1.23-5.42-4.44-8.63-4.04-1.23.15-2.31.83-3.35,1.5-10.28,6.55-14.85,10.61-27.02,6.85,0,0,0,0,0,0-4.8-1.48-7.84-3.67-7.51-8.99.15-2.41,1.02-5.27,2.21-7.41,5.28-9.44,15.5-14.11,24.95-17.88,13.09-5.22,16.11-14.65,16.17-27.74,33.51,6.96,64.28,21.4,90.49,41.49,3.31,4.89,2.33,10.18-3.91,19.43Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.31
    }
  }, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 178,
    height: 99,
    transform: "translate(108.5 242.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALIAAABjCAYAAAA/6FriAAAACXBIWXMAAAsSAAALEgHS3X78AAAEXklEQVR4nO3cbWvbaBBG4XtpcYlpadhCoWH//0/LwkLBIcUhpob9IE09mjxSZFsvI/lcIKzYDnHbk6cTWYoEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwrb/mfgGoPDw8fJBk20e377epHAvbb9t/fHw8TvhaeiHkCfSMtOsxu38qFu6h3l7dvn2cKmhCHsg7sW4kfdJ58ZYem4qtwhbwi6R9uE0VNCFfoCXajU7BbtQMsHTfJSvzVCxki/VF0rOkX+7Wgn6VdJg75o9zfvElOCNa//Gm5flLHS32kp4k7dT8hvTPJ+Qsroz2U3ju2kaLrU5/1tLzZnXTIRfC3ehtuH2jXfto4SOOj8/e0ewvYEo9wr1TM9JS0Lc6WviI7f6XepvytRWtOuQLwt0WnsNoUcVq91vYe1U/+MVxYxarCznEG+O6UzPWGO5W3RGPOVpkEl/7B0lf6u1zffukJBFLKwj5nVV3q+aq2xXymKNFxlj7sNd9VPffx+wWGfIZq24p3Du1h3vNaLH0aNs03p5u2Z/dYkLuiNfiLMVbCneI0WKt0UY2E9sPdfvC/kEJYk4dcs94/W2Md4jR4paijSutRbyT9CjpP0k/649/6fTOHiFHF8Tr968dLTKFWzzzLGxDf734dewIxU7Sv2qG/Fw/dqg/b1ZpQnYBt8X7WeV4rxkt5gi3b6Bdj48xm5a+jr0ZstMp4rgiM1oEFrEP1R/u+ar2VbnvaFE6njuGrlj/nDVW2HygnecEa9yQS6OFBbxTdejNr8iELP1ZjS1iH++9qoDv6+3c0WLsVbctssZ5u2GzNxneCzTbaGHx2hlwz6pn5LnPfJOShKzTIa07VRFbuN8k/V3f3qvfaDHWqtu2YvkTz2Osh47PWdJoEU/d9Kdwzh6xlC9kGycs4u9uaxstxoi3b7Tx6gl7vr+aYg2jRePcY//nzrAaS3lCtnfkbEX+qmol/i7pR7350WLoeOM/Yrysp7QfV14f55pGi9I36lHKcWWIyRKyzcilFfmHpH/q+4eK971w4+pTCvoWRouU0ZZkCtlWZB+y37a6PN5zw90XnpNqtMge1tRmD7k+YuHnYzti4fdtnDhH6b9zH66PNYa7V3fEo40WBHqZ2UMeWFu8/qftg7pDHnu0INYRZArZ/ku2yPZh/6i3s3HXyOB/0o4nucRL2oceLQh2YllCtijsqoOdqnEivktXCrltJS2twDHsa0cLok0iW8gvqg68P6l5/u9RVdD+HTr7vLaVtLQCXzNaEG1imUJ+VRWUP+/Xgj2oCtlfCSKVx4khRgvCXZhMIdtKGQ+xHVWFN+ZoQbgLlyVkW1n37j5/BOBZw44WjUNjhLt8WUK2ldX2/Uprv67pmtGCeFcuzS8xbLkyJJ4gdM5owchwQ9KE7LVcLRLPK5bejhaEe6NShmwKv7OihHABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwuf8BLejLY3VhH6YAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.31
    }
  }, _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 183,
    height: 116,
    transform: "translate(229.5 243.5)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m325.75,46.93c0,10.27-4.73,19.44-12.12,25.46-5.64,4.58-12.83,7.33-20.66,7.33-8.31,0-15.89-3.09-21.67-8.19-6.82-6.01-11.11-14.8-11.11-24.6,0-18.11,14.68-32.78,32.78-32.78s32.78,14.68,32.78,32.78Z",
    style: {
      fill: "#2a59be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.17,255.87c-2.22-1.47-4.4-3-6.54-4.6-.46-.35-.98-.83-.87-1.4.09-.46.56-.73.97-.94,1.08-.55,2.16-1.1,3.24-1.65-1.52-2.77-2.14-6.02-1.74-9.16.22-1.71.73-3.37.88-5.09.16-1.82-.1-3.67.06-5.49.36-4.08,3.09-7.94,6.94-9.34,3.85-1.4,8.61-.04,10.89,3.36,1,1.5,1.5,3.26,1.94,5.01,1.58,6.32,2.45,12.82,2.6,19.33.01.52.02,1.05.24,1.52.59,1.27,2.45,1.6,2.91,2.92-1.82,1.94-3.75,3.95-6.29,4.73-1.26.39-2.6.44-3.91.49-3.7.15-7.4.29-11.1.44l-.22-.14Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.04,246.54c2.97,1.71,6.51,2.41,9.91,1.97-1.66.52-3.32,1.04-4.99,1.56-.36.11-.73.23-1.11.24-.39,0-.78-.09-1.15-.23-1.76-.64-3.22-2.06-3.91-3.8.34.03.66.14.95.32l.29-.06Z",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.91,244.1c.79-.38,1.4-1.06,1.99-1.71,1.73-1.95,3.51-3.97,4.29-6.46.16-.51.32-1.09.8-1.32-.04,1.68-.47,3.35-1.25,4.84-1.16,2.21-3.11,4.01-5.45,4.9l-.38-.25Z",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.59,259.33c-10.88,1.43-21.94,1.56-32.86.41-.55-.06-1.11-.12-1.66-.19-.04,0-.08,0-.12-.01,0,0,0-.02,0-.02.27-3.99.55-7.97.82-11.96.12-1.68.23-3.36.34-5.04.21-3.15.43-6.31,1.02-9.4,1.1-5.76,3.56-11.32,7.43-15.72,2.05-2.33,5.01-4.45,8.02-3.69h.15c2.98-.17,6.1-.58,8.35,1.52,2.03,1.89,5.37,7.82,6.01,10.53,1.93,8.24,2.21,16.26,2.4,24.73.08,3.41-1.46,5.81.09,8.85Z",
    style: {
      fill: "#7a1123"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.63,218.31c-2.3-.32-4.74-.44-6.84.55-3.57,1.69-5.02,5.98-5.63,9.88-1.36,8.75-.3,17.68.76,26.47.03.28.09.6.31.77.22.17.52.15.79.12,1.88-.2,3.75-.4,5.63-.59.42-.04.87-.11,1.16-.41.33-.35.32-.89.29-1.37-.65-11.19.28-22.46,2.73-33.39",
    style: {
      fill: "#630d20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.84,218.51c2.24-.65,4.78-.2,6.66,1.19,2.49,1.84,3.62,4.99,4.24,8.02.92,4.48,1.01,9.12.27,13.64-.62,3.79-1.83,7.54-1.63,11.38.03.64.06,1.4-.45,1.79-.32.25-.76.26-1.16.25-.85-.02-1.7-.13-2.53-.32-.36-.08-.73-.19-.99-.45-.3-.31-.38-.76-.44-1.18-1.32-9.59,2.32-19.43.47-28.93-.19-.95-.43-1.92-.97-2.73-1.06-1.6-3.26-2.34-5.07-1.71.28-.58.9-.96,1.54-.96",
    style: {
      fill: "#630d20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.05,262.14c-5.45,8.7-15.13,14.48-26.16,14.48s-21.28-6.14-26.64-15.27c4.19-1.82,8.57-3.25,12.81-4.95,2.43-.98,4.82-2.04,7.09-3.33.59-.34,1.18-.69,1.75-1.06l-.17.26c2.35.68,4.84.08,7.28-.07,4.59-.28,9.17,1.04,13.3,3.08,3.81,1.88,7.29,4.35,10.73,6.86Z",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.82,243.68v9.98s-2.83,1.98-6.14,2.04c-3.31.06-5.07-2.75-5.07-2.75v-9.62l11.21.35Z",
    style: {
      fill: "#d67b78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.99,229.35s.57-10.03,6.92-10.32c6.36-.28,8.76-.28,10.74,2.4,1.98,2.69,1.7,12.29,1.7,12.29,0,0-.42,6.08-1.84,8.06-1.41,1.98-6.22,5.94-6.22,5.94h-3.16s-8.28-9.74-8.14-12.36c.14-2.62,0-6.01,0-6.01Z",
    style: {
      fill: "#d67b78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.52,240.57c-1.91-.04-3.83-.02-5.74.05-.37.01-.78.05-1.03.33-.29.33-.2.84-.04,1.25.54,1.33,1.78,2.35,3.18,2.63.65.13,1.35.1,1.92-.24.56-.34.9-.93,1.22-1.5.4-.72.82-1.51.68-2.32",
    style: {
      fill: "#d67b78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.54,256.09c.05.03.1.07.16.09-.01,0-.03.02-.04.03l-.12-.12Z",
    style: {
      fill: "#626d7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.96,259.75c.09.03.19.05.28.07-4.97.22-10.01-.99-14.17-3.42,2.43-.98,4.82-2.05,7.09-3.34-.24,1.55.57,3.16,1.83,4.27,1.35,1.19,3.15,1.9,4.97,2.41Z",
    style: {
      fill: "#626d7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.57,259.73c-.37.24-.87.2-1.33.09.44-.02.89-.05,1.33-.09Z",
    style: {
      fill: "#626d7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.93,254.31c-2.58,3.78-5.66,7.22-9.15,10.18,6.33-1.52,12.56-3.41,18.67-5.66-2.6-1.95-5.51-3.5-8.58-4.58",
    style: {
      fill: "#626d7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.19,244.14c-.1.29-.23.58-.37.85-1.27,2.42-4.02,4.02-6.76,3.84-.91-.06-1.88-.29-2.71.1-.89.42-1.32,1.41-1.68,2.32l.19.04c-.08.23-.17.46-.25.68v-8.24c.98.76,1.95,1.52,2.93,2.28.59.46,1.19.92,1.89,1.16,1.37.46,2.91-.04,4.04-.93.8-.63,1.47-1.45,2.35-1.92.12-.07.25-.12.37-.17Z",
    style: {
      fill: "#ba6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.17,236.04c-.57,1.5-1.46,2.89-2.58,4.04-.22.23-.47.46-.79.54-.28.07-.59.01-.87-.07-.93-.28-1.77-.86-2.36-1.63-.17-.22-.33-.46-.57-.61-.26-.15-.57-.17-.86-.18-.8-.04-1.59-.08-2.39-.11-.33-.02-.67-.03-.98.07-.89.29-1.26,1.38-2.04,1.9-.71.47-1.68.38-2.45,0s-3.05-2.74-3.64-3.36c1.64,2.41,4.1,6.13,5.73,8.54.67.98,1.38,2.01,2.44,2.54,1.28.65,2.63.82,3.91.15s2.73-1.88,3.67-2.97c2.09-2.41,3.25-4.38,4.16-8.37.05-.21-.16-.48-.37-.44",
    style: {
      fill: "#7a1123"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.14,77.18c-5.46,6.72-13.78,11.01-23.11,11.01s-18.16-4.56-23.59-11.63c.1-.16.19-.33.29-.48.04-.06.07-.12.11-.18.25-.4.51-.8.78-1.2.49-.73,1.01-1.44,1.57-2.13,3.22-3.96,7.81-7.17,13.02-7.69l.86-.04c4.38.21,8.83-1.63,13.07-.56,2,.51,3.77,1.62,5.5,2.72,1.84,1.18,3.69,2.35,5.4,3.7.09.07.18.14.27.21,2.25,1.81,4.2,3.93,5.83,6.27Z",
    style: {
      fill: "#673a91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.16,70.96c-6.21-3.64-13.83-4.38-20.91-3.09-6.77,1.23-13.11,4.21-19,7.78.12-.32.25-.64.38-.96.49-.73,1.02-1.44,1.57-2.13,3.21-3.96,7.81-7.17,13.02-7.69l.86-.05c4.38.21,8.83-1.63,13.07-.56,2,.5,3.77,1.62,5.5,2.72,1.84,1.17,3.69,2.35,5.4,3.7.04.09.08.18.11.27Z",
    style: {
      fill: "#4f2d77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.26,46.76c-.69.34-1.58.1-2.03-.51-.48-.66-.41-1.91-.25-2.71.24-1.25,2.41-1.51,2.96-2.1.55,1.61-.38,3.88-.25,5.58",
    style: {
      fill: "#f9ddd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.37,58.4s.45,8.49,0,10.11c0,0,.95,3.57,5.21,3.17,4.26-.4,5.91-2.26,5.91-3.56v-9.32l-11.12-.41Z",
    style: {
      fill: "#f9ddd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.16,34.94v16.87s-.4,5.38,4.21,6.58c4.61,1.2,12.19.5,13.14,0s3.4-2.46,3.4-6.82-.5-13.03-.5-13.03c0,0-6.54-3.61-3.47-3.61,0,0-16.78,0-16.78,0Z",
    style: {
      fill: "#f9ddd2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m100.98,41.94c-1.13-.15-2.17-.85-2.74-1.84s-.66-2.24-.22-3.29c.24-.59.63-1.11.91-1.69s.43-1.27.17-1.85c-.35.04-.69-.21-.85-.52s-.2-.68-.24-1.03c-.06-.58-.11-1.17-.17-1.75-.12-1.23-.2-2.59.52-3.59.41-.56,1.03-.94,1.67-1.22.76-.34,1.6-.57,2.42-.44s1.62.66,1.86,1.46c-.13-.45.11-.98.54-1.18s.98-.05,1.25.33c.53-.57,1.16-1.11,1.91-1.31s1.67.02,2.08.69c.98-1.57,3.02-2.26,4.85-1.97s3.44,1.41,4.67,2.78c1.19,1.33,2.12,3.15,1.58,4.85.76-.29,1.67-.12,2.29.41s.9,1.42.71,2.21c.8.11,1.36,1.08,1.05,1.83-.12.29-.35.55-.38.87-.03.38.24.72.23,1.1-.01.37-.28.68-.38,1.03-.1.37,0,.76.06,1.14.2,1.35-.18,2.77-1.02,3.84.2-.14.5.03.57.27s-.03.48-.15.7c-.4.71-1.12,1.24-1.93,1.41-.23.05-.5.06-.69-.09-.16-.14-.21-.36-.24-.57-.29-1.66-.58-3.32-.87-4.99-.06-.32-.13-.67-.38-.88-.19-.16-.45-.21-.69-.27-1.14-.31-2.12-1.18-2.57-2.28-.1-.23-.18-.5-.4-.63-.16-.1-.37-.1-.56-.1-4.72.08-9.43.16-14.15.24.41,2.14.09,7.06-.54,9.14",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m101.13,44.75c-.01.05,0,.03.05-.12v-.11s-.05.23-.05.23Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.39,43.77c.02-.18.05-.38.01-.27-.03.21-.02.16-.05.41-.03.15-.06.26-.06.23-.02.08-.03.13-.07.31.06-.19.12-.44.16-.69.01-.05,0,0,0,.01Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.44,35.53h-.1.1Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117,36.57s-.04-.07-.05-.09c.03.06.06.1.05.09Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.04,37.77s-.05-.04-.07-.06c.03.03.05.04.07.06Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.44,35.53h.25s-.13,0-.25,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.65,41.73s0,.09-.01.13v-.12s.01,0,.01,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.36,35.61h-.07s-.04,0-.06,0h.14Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.81,36.08c0-.07-.03-.09-.04-.12.01.04.02.09.03.15,0,0,0,0,0-.03Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.77,41.03v.09s0-.06,0-.09Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.6,35.58s.02,0,.03,0c0,0-.01,0-.03,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.2,39.89h0s.01.02,0,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.98,41.94h-.05s-.01,0-.01,0h.06Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.32,39.25h0c-.02-.08,0-.04,0,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.3,30.19c-.08.27.1-.47-.02-.04,0-.03-.02.1-.01.11,0,.01,0,.04.03-.07Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.66,41.65v-.13c0,.06,0,.09,0,.13Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.28,30.15v.05s0-.03,0-.05Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.19,45.26s-.05,0-.07,0c0,0,.02,0,.07,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.64,40.91l.02.12c0-.05-.01-.09-.02-.12Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.23,43.75c.03-.06.05-.08.08-.17v.03s-.04.07-.08.14Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.44 41.73 124.42 41.77 124.38 41.85 124.44 41.73",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.27,32.68s.03.07.05.11c-.01-.04.19.27-.05-.11Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.66,41.73s0-.04,0-.08v.09s0,0,0,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.18,43.6c.06-.12.1-.25.09-.38,0,.11-.03.25-.09.38Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.51,24.01h-.09s.06,0,.09,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.93,42.45c.05-.06.09-.12.13-.2,0-.01.01-.03.02-.04-.05.08-.1.16-.16.24Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.32,32.79h0s0,0,0,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.03,35.07c.16-.38.06-.19.08-.27.14-.47.08-.21.13-.38.06-.31.05-.55.01-.78,0-.02,0-.06,0-.01-.02-.08-.04-.18-.08-.29l-.04-.1c0-.06-.08-.01-.12-.02-.05,0-.11,0-.17-.02-.22-.05-.41-.22-.52-.36,0-.02-.02-.03-.02-.04.02.05.02.07,0,.06-.1-.15-.16-.29-.17-.36.04.1.05.11.07.16-.03-.06-.05-.11-.07-.17-.04-.16.09.24.11.23-.18-.32-.22-.76-.24-1.04,0-.06.08.66.05.28.01.15.03.29.07.43-.05-.33.06.25.02-.05-.1-.56-.09-.63-.15-1.21-.02-.13,0,.04-.03-.08-.09-.82-.02-.65-.1-1.25-.02-.15-.06-.21-.07-.64l.03.15c-.02-.56-.05-.32-.03-.9,0,.1,0,.44,0,.35.02-.38-.01-.27,0-.56l.02-.06c.04-.58.19-1.24.59-1.77-.02.03-.08.12.02,0,.49-.67,1.38-1.09,2.13-1.34l.29-.11c.07-.02.13-.03.06,0,.3-.07.01-.01.16-.06.17-.04.23-.04.12-.01.26-.07.65-.13,1.05-.1.39.02.78.15,1.02.3l-.1-.05c.38.21.46.22.74.53l-.06-.06c.14.17.23.25.39.62.05.02.06.06.08.09-.01-.04-.02-.08.03-.14-.03-.37.03-.4.09-.56.06-.13.15-.24.26-.33.21-.18.48-.22.69-.18.07,0,.3.04.48.18.04.03.09.07.12.11.03,0,.1.18.14.11.11-.12.12-.14.14-.16.41-.37.28-.29.92-.74.18-.11.25-.18.49-.29h.01c.1-.04.21-.08.32-.12l.18-.02c.08-.01.16-.03.24-.03-.1,0-.2.02-.19.01.38-.09.91.05.91.07.28.08.55.22.75.43-.02-.01-.12-.11-.22-.18.19.14.19.17.2.18,0,0,0,.01.03.04.02.02.05.05.16.22-.05-.1.03.05.04.01.14-.19.19-.28.34-.45.12-.15.28-.31.41-.43l-.05.05c.49-.44,1.14-.82,1.86-1.02-.26.07-.21.03,0-.03h.09c.13-.05-.22.05.05-.04.27-.06.19-.02.03.02l.33-.08s-.06.02-.08.03c.13-.05.58-.07.78-.1h.02c.74,0,1.08.05,1.67.19.02-.01.24.06.42.11.42.15.87.37,1.34.64.33.19.1.05.25.13.02.02.46.33.23.18.53.38.67.49,1.28,1.04-.06-.07-.13-.14-.09-.1.11.1.24.24.22.23l-.03-.03c.68.63,1.35,1.65,1.66,2.32l-.02-.04c.11.23.21.46.29.7.09.34-.07-.2,0,.05.24.78.22,1.28.1,1.93-.01.04-.02.07-.03.1l-.06.22c-.03.06.03.03.06.02l.12-.04c.1-.04.11-.03.17-.05.2-.05.43-.07.67-.05.48.02.95.24,1.21.46l-.03-.03c.14.1.16.14.25.24,0-.02-.13-.14-.05-.07.27.26.47.61.58.98.05.19.08.38.08.58,0,.1,0,.2-.02.29,0,.05-.01.09-.02.15l-.03.13.13.03c.77.17,1.23,1.13.88,1.81-.13.25-.17.33-.21.43-.02.1-.13.21-.1.61-.02-.07-.03-.15-.03-.22-.02.33.15.6.21.88.08.28-.04.55-.18.82-.15.26-.25.58-.22.89.02.31.09.59.12.87-.01-.07-.02-.07-.03-.18.04.24.06.89.06.89,0,.18,0,.04-.02.15-.02.24-.06.6-.1.73,0,.02,0-.07.02-.11-.01.16-.18.71-.13.57-.13.41-.29.77-.47,1.06-.04.08-.12.2-.19.31-.06.09-.13.17-.19.25-.09.11-.04.06-.1.16.25-.14.27-.14.31-.16.02,0,.18,0,.31.18.12.16.07.43.02.55.03-.08-.1.21-.07.11-.14.27-.32.49-.27.45-.36.43-.84.77-1.15.86-.39.16-.91.35-1.2.04-.13-.15-.16-.37-.2-.58-.04-.21-.08-.42-.11-.62.03.02.16.91.18.87-.15-.77-.24-1.22-.38-2-.03-.2.03.11.04.18-.14-.79-.26-1.47-.39-2.2,0,.03.02.09.03.15-.02-.14-.05-.32-.06-.3l.03.13c.02.22-.13-.54-.14-.56.07.23-.11-.69-.01-.32-.02-.09-.04-.2-.05-.18-.02-.13-.03-.18,0-.04-.12-.49-.05-.33-.26-.74,0,0,.06.08.08.12-.11-.21-.31-.4-.69-.49.02,0-.02-.01.09.02-.63-.16-1.08-.3-1.65-.73.18.11-.19-.15-.2-.2-.09-.08-.19-.17-.28-.26l.1.12c-.24-.24-.43-.46-.58-.71l.14.2c-.12-.17-.23-.35-.32-.54.05.11.1.21.17.31-.18-.29-.01.05-.21-.35-.03-.08-.1-.25-.19-.48h0c-.08-.14-.18-.31-.43-.39-.06-.02.06,0,.02-.02-.17-.06-.8-.02-1.01,0,.07,0,.07-.01.05-.02l-.14.02c-.16,0-.18,0-.15-.01-.47,0,.15.02-.41.02.04,0,.04,0,.11,0-.57.01-1.07.02-1.6.03-.15-.02.45-.01.28-.02-.73.02-1.54.04-2.26.06h.13c-.1.03-.54,0-.9.01.09,0,.12-.02.09-.01-.49.01-1,.03-1.75.04h.09c-.31,0-.76,0-1.08,0-.09,0-.27.01-.16.02-.97-.02-1.84.05-2.7.03.1,0,.24,0,.16,0l-.73.02c.06.01.1,0,.25.01-.14,0-.32.01-.48.02.33-.01,0-.02-.15-.02.02,0-.02,0-.01.01-.38-.01-.06.02-.58.02h.03c-.19,0-.38,0-.58.01-.09-.01.21,0,.22-.02-.3,0-.58.04-.85.03.14,0,.29,0,.43-.01-.29-.01-.33,0-.54,0h.02-.25s-.13-.01-.15.01l.02.16-.02-.16c.11.43.12.76.17,1.27-.05-.48-.02-.08-.04-.12,0,.13.01.32,0,.27.02.23,0,.39.03.72,0,.01,0,.25-.01.2,0,.31,0-.07.01-.05.03.47-.02,1.11-.03,1.78-.02.58-.01.69-.04,1.24-.02.18,0-.15,0-.15-.03.32-.04.5-.07.79,0-.06,0,0-.02.08-.02.22,0,.15-.04.44,0-.06,0-.15,0-.22-.03.25-.05.53-.08.79-.02.07,0-.17.02-.26-.03.3-.11.79-.11.88l.03-.19c-.02.11-.02.05,0-.03.03-.26.06-.37.07-.39l-.02.19c.06-.19.1-.77.14-1.16v.16s.03-.4.03-.4c.01-.08.03-.14.02.05.03-.31.02-.19.05-.49,0-.03,0-.01,0,.01l.02-.27c0,.05.02-.04,0,.12.05-.49.04-.79.06-.98v.04c.03-.68,0-.07,0-.58l.05-.34v-.07c0-.07,0-.21,0-.18,0-.26,0,.04-.02-.11.02-.34,0-.93.02-1.01-.01-.12,0,.32-.02-.04.02-.1-.01-.42-.02-.73.02.09.03.39.02.08-.03-.19-.04-.6-.07-.86,0,0-.03-.15-.06-.34,0-.04-.01-.09-.02-.13h.15s.34-.01.34-.01c.12,0,.82,0,1.23,0h-.01c.08-.02.5-.02.8-.03-.01.01-.07.02-.23.02h.29c.07-.01.16-.02.34-.02h-.07c.37,0,.75,0,1.26-.01.03-.01-.39-.03.13-.05.02,0,.04.02-.1.02.04,0,.15,0,.25,0l-.21.02c.22,0,.12-.01.3-.01,0,0,.13,0,.11.01-.05,0-.13,0-.23,0,.2,0,.45,0,.53,0-.02,0,0-.01.15-.02.38,0,.13,0,.35.01.09,0,.34,0,.34-.02.11,0,.13,0,.18,0,.2,0,.93-.02.7-.03h-.05.03s0,0,0,0h0c.7-.01,1.35-.02,1.99-.03h0c.39,0,.8-.02,1.13-.03.11,0,.27,0,.22.01.29,0,.33-.01.75-.01-.3.01.1,0-.3.01.38,0,.47,0,.88-.02-.14.02.29.01.47,0h-.27c.21,0,.38-.01.56-.01l-.1.02c.78,0,1.41-.06,2-.03.21-.02-.42,0-.24-.02.36,0,.74,0,.83.05.21.07.27.17.34.26.07.09.12.2.21.44-.02-.06-.04-.12.13.22.17.32.2.4.08.2-.05-.07-.06-.11-.06-.11-.06-.1-.13-.24-.07-.11l.03.04c.07.17.35.58.28.49.17.22.07.09-.04-.08.26.39.45.57.82.89-.06-.05-.11-.1-.05-.05.56.43.25.18.66.43.24.13-.1-.02.34.18.27.11.05.04-.06,0,.4.17.79.24.99.34-.06-.03-.13-.05-.21-.07.13.04.23.08.31.13-.03-.02-.06-.05-.1-.07.11.06.19.13.18.13.09.09-.05-.09.13.1.11.14.21.49.2.55-.14-.53.02.05-.13-.38.04.08.07.18.1.31,0,.02,0-.02-.02-.05.09.52.06.24.16.78-.02-.07,0,.13.02.22-.04-.22,0-.11.04.09.05.35.07.38.1.57l-.03-.21c.02.07.05.25.1.49,0,.02-.04-.22-.03-.13.06.27.09.62.17,1,.02.18-.01.02,0,.17.08.46.08.45.16.91-.01-.13-.02-.15.05.16l-.14-.73.1.47c-.04-.22-.09-.46-.11-.6.05.22.04.2.03.09.04.31.12.6.16.95h-.03c.05.28.09.49.13.75.07.24.04.55.27.86-.05-.06-.09-.13-.12-.21.02.04.07.15.17.24.1.09.25.13.37.14-.02.01.13.02.23.01,0,.01.51-.11.56-.17.1-.03.2-.07.29-.12.5-.28.54-.36.92-.76-.1.13.08-.05-.17.22.13-.13.23-.26.23-.26.08-.08.29-.42.35-.58.02-.08.04-.1.07-.31,0-.02,0,0,0,0,.02,0-.04-.33-.02-.14.02-.2-.27-.47-.48-.42-.1.04.17-.26.26-.44.12-.2.21-.39.29-.53.16-.36.29-.82.35-1.18,0,.02,0,0,0,.07.09-.49.03-.3.08-.86.02-.29,0,.3.01.12.05-.08,0-.68-.05-1.06l.02.09c-.02-.29-.18-.7-.06-1.15,0,0,0,.02,0,0,.05-.29.5-.85.3-1.32.05.13.05.2.05.11-.05-.2,0,.06-.12-.33-.04-.13-.11-.41-.09-.45.01.12.05.24.09.36-.05-.19-.13-.47-.05-.66v.03c.18-.53.34-.5.41-1.15v.07c-.03-.35,0-.3-.11-.63,0-.04-.01-.07-.02-.1-.08-.22-.49-.68-.92-.75.24.01.67.3.83.56-.1-.22-.57-.55-.7-.55.09.03.2.08.27.13-.12-.07-.29-.14-.45-.16-.03-.08.04-.36.02-.56.02.04.03-.26-.08-.6-.09-.34-.31-.68-.41-.81-.52-.62-1.37-.98-2.31-.78.34-.04-.28.06-.18.08-.1.06-.02-.06-.03-.07.01-.04.02-.06.02-.08.06-.21.1-.43.11-.65.02-.16,0,.21,0,.19.03-.48.03-.2.03-.52,0,.07-.02-.17-.05-.44.01.13.02.26.03.38-.09-.66-.04-.58-.25-1.22l.08.2c-.09-.34-.49-1.18-.7-1.44-.03-.05-.06-.13.02,0-.42-.71-1.13-1.43-1.59-1.87l.05.04c-.11-.11-.21-.17-.34-.3,0,0,.05.04,0-.01-.07-.06-.32-.25-.48-.37l.14.1c-.63-.49-1.02-.69-1.62-.98.02-.03-.56-.28-.87-.37h.01c-.89-.27-1.57-.31-2.43-.2-.54,0-1.8.41-2.47.98.11-.08,0,.02-.12.13-.16.12-.39.4-.38.36l.05-.05c-.06.05-.15.16-.26.28-.05.06-.09.13-.14.2,0,.02-.02,0-.04-.03l-.06-.03c-.26-.36-.82-.62-1.34-.62-.52-.03-.97.17-1.18.25-.18.09-.4.23-.56.36v-.02c-.23.17-.39.31-.56.47-.08.08-.16.17-.26.26-.02,0,0,.03-.04-.03-.05-.06-.12-.11-.2-.17.04.03.09.05.13.08-.34-.25-.49-.23-.85-.23-.04,0-.08,0-.12,0-.23.05-.44.19-.58.37-.07.09-.13.2-.17.31-.02.06-.04.11-.05.17v.06s0,.04,0,.07c0-.01-.01-.03-.02-.05l-.04-.07s.02,0,.04.04c0-.01-.02-.03-.03-.05-.03-.05-.06-.1-.1-.15-.08-.11-.18-.22-.28-.31-.2-.18-.38-.27-.34-.23.02-.04-.64-.36-1.02-.37h.06c-.32-.03-.33-.03-.77,0-.1,0-.09,0,.05-.01-.35.03-.27.03-.68.11l.15-.04c-.35.07-.32.08-.5.14-.2.07-.48.17-.69.24-.11.06-.25.13-.4.21-.03,0,.04-.03.07-.05-.54.26-.76.46-1.07.73,0,0-.03.02-.06.04.34-.34.68-.52.65-.51,0-.01-.33.2-.08.01-.26.17-.66.53-.87.85,0,.01-.02.02-.03.04l.02-.03c-.05.07-.1.14-.13.2-.06.1-.1.17-.14.28-.04.03-.17.41-.2.6.02-.01-.04.23.02,0,0,.03,0-.04.04-.16,0-.03.01-.06.02-.08h0c.03-.11.09-.26.17-.43-.06.14-.11.29-.18.49-.02.1-.03.2-.04.26-.08.25-.13.75-.14.82-.02.58.06,1.37.12,1.73.02.16.01.19.01.25-.01-.1-.02-.18-.03-.26.04.33.1.97.12,1.05.03.41-.04-.23.02.34v-.08c.03.55.05,1.04.33,1.45.14.19.34.36.61.42.06.01.15.02.19.01.03.02.05.1.07.16.04.13.06.28.06.43,0-.07,0-.1,0-.14.12,1.47-1.34,2.55-1.45,4-.04.4-.03.44,0,.69v.09c0,.14.03.28.06.41.13.57.23,1.02.71,1.61l-.05-.08c.15.23.58.62.54.6.03.02.07.05.15.12h0c.18.14.36.26.56.36.46.23-.1.02.6.3.26.1.78.15.68.13-.11-.02-.28-.05-.29-.07.08.02.17.03.25.04.05-.02.24,0-.36-.14-.14-.03-.27-.07-.41-.12l-.12-.06c.11.05.22.09.33.13-.23-.09-.3-.11-.44-.17-.03-.02-.08-.05-.15-.09-.13-.06-.25-.12-.37-.2-.04-.04.16.09-.06-.07-.17-.11.14.13-.13-.06-.15-.14-.1-.1-.29-.26-.02-.03.02,0,.09.07-.17-.13-.4-.4-.47-.48-.13-.17-.39-.6-.36-.6-.03-.06-.18-.33-.23-.52.11.34-.19-.71-.11-.63-.08-.26-.07-.96.05-1.41,0,.03-.02.08-.02.12.06-.26.09-.33.15-.48-.01-.04.14-.42.24-.62.17-.28-.07.18,0,.1-.03,0,.26-.5.2-.41.14-.21.11-.18.19-.29,0-.05.12-.2.2-.4.17-.32.07-.07.22-.44.08-.18-.05.16-.05.16Zm-.61-8.71c-.05.06-.08.12-.11.16.02-.03.05-.08.11-.16Zm.56-.55c-.08.06-.17.13-.26.22-.02.02,0,0,.05-.06-.03.03.11-.09.21-.16Zm-1.06,1.29c.04-.12.06-.16.07-.18-.03.05-.05.12-.08.21,0,0,0,0,0,.01,0-.02,0-.04.01-.05Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.87,27.32s0,.03-.01.05c0-.03.02-.05.02-.07v-.04s-.01.07-.01.07Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.33,35.53h.02-.04s.01,0,.02,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.68 24.2 107.68 24.2 107.61 24.23 107.68 24.2",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.94,35.55s-.03,0-.06,0c.01,0,.03,0,.06,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.05,35.58h-.28c.12,0,.21,0,.28,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.8,36.73s0,.02,0,.03h0s0-.03,0-.03Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.72,40.8v.06c.04.13.02.04,0-.06Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.7,35.8c.04.07.07.13.1.2-.04-.11-.09-.2-.1-.2Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.16 43.64 124.16 43.64 124.18 43.6 124.16 43.64",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.92,36.29c-.05-.12-.09-.2-.13-.29.04.09.08.2.13.29Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.48,43.01v.07s-.01,0-.01,0v-.08Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.47,43.09v.08s0-.05,0-.08Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.44,43.33l.02-.16s-.01.09-.02.16Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.72,41.1v-.02s0,.02,0,.02Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.76,40.52c-.01.13-.03.35-.05.54v.02c0-.09.05-.43.05-.56Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.91,38.08v.49c0-.09,0-.2,0,.02.02-.62,0,.13,0-.52Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.85,36.55c.02.26,0,0,.01,0-.02-.17-.03-.21-.01,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.76,35.48h-.03c.2,0,0,0,.03,0Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.86 35.38 113.67 35.38 113.57 35.39 113.86 35.38",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.11 35.45 115.02 35.46 115.36 35.44 115.11 35.45",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.24,42.16l-.04.05c-.07.12-.07.16.04-.05Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.36,34.48c.03-.09.01-.32-.04-.46.05.18.05.37.04.46Z",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.71,24.22s.09.06.14.1c-.08-.07-.17-.13-.26-.18.04.02.08.05.12.08Z",
    style: {
      fill: "#202020"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m121.83,46.93c.47.1.97-.15,1.28-.52s.46-.85.54-1.33c.05-.29.09-.6.04-.89-.13-.89-.99-1.57-1.89-1.64-.1,0-.2,0-.27.07-.05.06-.06.15-.05.24.04,1.23.07,2.46.11,3.68",
    style: {
      fill: "#f9ddd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.37,40.96c-1.91,0-3.46,1.55-3.46,3.46s1.55,3.46,3.46,3.46,3.46-1.55,3.46-3.46-1.55-3.46-3.46-3.46Zm-.03,6.46c-1.65,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Z",
    style: {
      fill: "#1c2538",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".05px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.34,
    cy: 44.44,
    r: 2.98,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.89,40.96c-1.91,0-3.46,1.55-3.46,3.46s1.55,3.46,3.46,3.46,3.46-1.55,3.46-3.46-1.55-3.46-3.46-3.46Zm-.03,6.46c-1.65,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Z",
    style: {
      fill: "#1c2538",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".05px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.87,
    cy: 44.44,
    r: 2.98,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".04px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.83 45.49 109.5 45.49 109.5 43.03 112.06 43.03 112.06 45.49 112.61 45.49 112.61 42.3 108.83 42.3 108.83 45.49",
    style: {
      fill: "#1c2538",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.49,62.14s-6.69-1.82-11.12-3.75c0,0,7.84,1.79,11.12.41v3.34Z",
    style: {
      fill: "#e0c5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.01,136.81v8.25s1.13,4.19,4.5,3.98,4.02-4.44,4.02-4.44v-7.8h-8.52Z",
    style: {
      fill: "#aa7536"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.35,127.05s.31-6.58,4.49-6.27c4.18.31,3.72-.23,5.46-.01s4.11,1.26,4.39,6.28c.28,5.02-2.86,11.18-5.68,11.7s-1.15.42-3.7,0c-1.59-.26-4.03-3.66-4.35-6.27-.31-2.61-.63-5.43-.63-5.43Z",
    style: {
      fill: "#aa7536"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.94,121.7c-1.51.05-3.01.1-4.52.15-.44.01-.91.04-1.28.28-.35.22-.56.61-.71.99-.56,1.35-.61,2.86-.66,4.32-.03.97-.06,1.94-.09,2.91-2.15-3.47-3.08-7.66-2.62-11.71.11-.95.3-1.91.81-2.72.61-.97,1.62-1.62,2.66-2.08,3.85-1.69,8.27-1.13,12.44-.53-.79,0-1.57.19-2.28.53,1.11.62,2.47.78,3.7.44-.35.3-.7.61-1.05.91-.07.06-.14.12-.17.21-.04.11,0,.22.05.32.39.7,1.61.49,2.02,1.18.15.25.15.55.15.84,0,4.87-.07,9.99-2.45,14.23.23-2.33.45-4.72-.18-6.98-.27-.97-.71-1.93-1.46-2.6-1.21-1.09-3.16-1.25-4.52-.38",
    style: {
      fill: "#d4d8df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.02,161.32c-2.96,1.34-6.24,2.08-9.69,2.08-1.7,0-3.36-.18-4.96-.53.53.04,1.05.07,1.58.08,4.41.12,8.83-.43,13.08-1.63Z",
    style: {
      fill: "#9f00ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.75,153.17c-.14.21-.29.41-.44.61-.03.04-.06.08-.08.11-.12.16-.24.32-.36.47-.03.04-.06.08-.09.12-.16.2-.32.39-.48.59-.12.14-.24.28-.37.42-.09.1-.19.21-.28.31-.28.31-.57.6-.87.89-.09.09-.18.17-.27.26-.08.08-.16.15-.24.22-.17.16-.35.32-.53.47-.04.04-.08.07-.12.11-.38.33-.77.64-1.17.94-.14.1-.28.2-.41.3-.42.3-.84.58-1.28.86-.15.09-.29.18-.44.27-.15.09-.29.17-.44.26-.01,0-.03.01-.04.02-.14.08-.28.15-.41.23-.12.06-.23.12-.35.18-.09.05-.18.09-.27.14-.25.13-.51.25-.77.36-4.24,1.2-8.67,1.76-13.08,1.63-.53-.01-1.05-.04-1.58-.08-.14-.03-.28-.06-.42-.09-.1-.02-.21-.05-.31-.07-.19-.05-.39-.1-.58-.15-.17-.04-.34-.09-.5-.14-.07-.02-.15-.04-.22-.07-.16-.05-.33-.1-.48-.16-.26-.09-.52-.18-.78-.28-.15-.06-.3-.11-.45-.17-.05-.02-.1-.04-.15-.06-.18-.07-.36-.15-.53-.23-.16-.07-.32-.14-.47-.21-.01,0-.02-.01-.04-.02-.1-.05-.2-.09-.29-.14-.11-.05-.22-.1-.33-.16-.21-.11-.43-.22-.64-.33,0,0,0,0,0,0-.64-.35-1.26-.72-1.87-1.12-.2-.13-.4-.27-.6-.41-.59-.42-1.16-.87-1.71-1.34-.04-.04-.09-.08-.13-.11-1.57-1.36-2.95-2.93-4.11-4.67.47-1.17,2.33-5.64,4.09-6.33,1.7-.67,3.43-1.25,5.17-1.82,1.99-.65,4.08-1.28,6.15-.98l4.88,2.58c4.29-3.39,5.08-3.27,7.84-3.39,2.76-.13,4.34.25,6.52,1.93,1.62,1.25,3.01,2.84,3.78,4.74.45,1.11.66,2.33.59,3.52Z",
    style: {
      fill: "#9f00ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.01,140.03s3.48.93,4.59.82,3.93-1.27,3.93-1.27v-2.77s-1.7,2.42-4.35,2.03c-2.65-.4-4.17-2.03-4.17-2.03v3.22Z",
    style: {
      fill: "#966229"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.04,65.16c-.24.46-.51.9-.8,1.33,0,0-.01.01-.02.02-.07.11-.15.22-.23.33-.05.07-.11.15-.16.22-.62-.26-1.21-.49-1.29-.4-.12.15-.3.25-.47.35-.44.24-.89.49-1.37.63-.61.18-1.25.19-1.89.2-3.89.03-7.78-.21-11.64-.73-1.31-.18-2.61-.38-3.9-.67-.16-.04-.34-.08-.44-.21-.07-.1-1.03,1.07-1.48,1.35-.02-.02-.04-.04-.05-.06-.06-.07-.12-.15-.18-.22h0c0-.12,0-.24.02-.36.2-2.22,2.04-5.66,2.79-7.47.82-1.99,2.26-3.8,4.22-4.69l.25-.22c2.63-.2,5.27-.29,7.9-.27.7,0,1.4.02,2.07.18,2.21.52,3.82,2.56,4.42,4.74.42,1.53,1.67,3.91,2.25,5.97Z",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.23,66.49s-.01.01-.02.02c-.07.11-.15.22-.23.33-.05.07-.11.15-.16.22-.01.01-.02.03-.03.04-.06.08-.12.16-.19.24-.06.08-.13.17-.2.25-.07.08-.13.16-.2.24-.01.01-.02.03-.04.04-.07.08-.14.16-.21.24-.12.13-.24.26-.36.38-.1.1-.19.19-.29.29-.07.07-.15.14-.22.21-.06.06-.12.11-.18.17-.29.26-.59.5-.9.74-.09.07-.18.14-.28.21-.49.35-1,.67-1.54.96-.12.07-.25.13-.37.19-.15.07-.29.15-.44.21-.11.05-.23.1-.34.15-.13.06-.26.11-.39.16-.01,0-.02,0-.03.01-.13.05-.26.1-.39.14-.1.04-.21.07-.31.11-.08.03-.17.06-.25.08-.23.07-.46.14-.69.2-.12.03-.23.06-.35.09-.07.02-.14.03-.21.05-.02,0-.04,0-.05.01-.1.02-.21.04-.32.06-.12.02-.25.04-.37.06-.15.02-.29.05-.44.06-.11.01-.21.03-.32.04-.07,0-.13.01-.2.02-.14.01-.29.02-.43.03-.29.02-.58.02-.87.02-.15,0-.29,0-.44,0-.26,0-.52-.02-.77-.04-.18-.02-.37-.04-.55-.06-.12-.01-.23-.03-.35-.05-.05,0-.11-.02-.16-.02-.1-.01-.2-.03-.3-.05-.1-.02-.21-.04-.31-.06-.09-.02-.18-.04-.27-.06-.05-.01-.1-.02-.15-.03-.1-.02-.2-.05-.3-.07-.17-.04-.34-.09-.51-.14l-.21-.07c-.1-.03-.2-.07-.3-.1-.1-.03-.19-.07-.28-.1-.07-.02-.14-.05-.21-.08-.36-.13-.7-.28-1.04-.45-.12-.06-.25-.12-.37-.18-.09-.05-.19-.1-.28-.15-.95-.51-1.82-1.12-2.63-1.82l-.21-.18c-.06-.05-.11-.1-.16-.15-.28-.26-.54-.53-.8-.81-.07-.07-.13-.14-.19-.21,0,0-.02-.02-.02-.02-.07-.09-.15-.17-.22-.26,0,0-.01-.01-.02-.02-.02-.02-.04-.04-.05-.06-.06-.07-.12-.15-.18-.23-.07-.08-.13-.17-.2-.26.07-.04.14-.07.21-.1.29-.14.59-.28.89-.41,2.19-.96,4.5-1.59,6.8-2.22.52-.14,1.04-.28,1.56-.41.91-.22,1.82-.4,2.75-.44.78-.04,1.56,0,2.33.12,1.48.21,2.94.67,4.35,1.18.37.13.74.27,1.11.41.78.29,1.55.6,2.31.93.15.06.29.12.44.19.18.07.36.15.55.23Z",
    style: {
      fill: "#eb0037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.09,65.13c-3.47,1.26-7.11,2.06-10.79,2.37-.13-.16-.26-.32-.38-.48.36-.18.73-.35,1.1-.51,2.19-.96,4.5-1.59,6.8-2.22.52-.14,1.04-.28,1.56-.41.04.03.08.06.12.08.53.39,1.06.78,1.59,1.17Z",
    style: {
      fill: "#7a1123"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.23,66.49s-.01.01-.02.02c-3.26-1.17-6.77-1.65-10.23-1.4l.39-.53c.37-.34.73-.69,1.1-1.03,1.48.21,2.94.67,4.35,1.18.37.13.74.27,1.11.41.78.29,1.55.6,2.31.93.15.06.29.12.44.19.18.07.36.15.55.23Z",
    style: {
      fill: "#7a1123"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.37,41.25c-1.92-.34-3.98.32-5.35,1.71-1.52,1.54-2.11,3.83-1.94,5.99s1.03,4.21,2.08,6.1c-.44-1.69-.64-3.48-.24-5.19s1.47-3.3,3.06-4.04c.95-.44,2.02-.55,3.07-.6,1.08-.06,2.26-.03,3.1.65.75.61,1.06,1.61,1.23,2.57.4,2.24.29,4.58-.32,6.77,1.3-.77,1.68-2.45,1.87-3.95.16-1.22.28-2.45.15-3.67s-.52-2.44-1.29-3.4c-.82-1.02-2.01-1.68-3.17-2.3-.79-.42-1.64-.85-2.54-.81",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.55,58.81v4.94s.6,1.4,2.63,1.45c2.03.05,2.95-1.28,2.95-1.28v-5.06l-5.58-.06Z",
    style: {
      fill: "#a2816c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.55,60.78s1.52.72,3.09.69,2.49-1.01,2.49-1.01v-1.58l-5.58-.06v1.97Z",
    style: {
      fill: "#84614e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.82,47.22s1-2.99,5.15-3.16,5.73,2.66,5.9,3.49.25,4.82.33,5.57c.08.68-1.1,4.28-4.12,6.69-.53.42-1.19.64-1.87.64h0c-.91-.01-1.76-.44-2.31-1.16-.77-1.01-1.9-2.74-3.08-5.39-1.5-3.35,0-6.68,0-6.68Z",
    style: {
      fill: "#a2816c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.95,66.14c1.9.75,3.95,1.14,5.99,1.14.98,0,1.97-.1,2.88-.43.92-.33,1.77-.93,2.27-1.76-.44-.46-.96-.84-1.53-1.12-.43-.22-.92-.38-1.4-.31-.35.05-.67.21-.99.36-1.27.57-2.83.85-4.02.11-.24-.15-.48-.34-.76-.33-.16,0-.3.08-.44.16-1.15.62-2.28,1.28-3.38,1.98.22-.03.45.02.63.14",
    style: {
      fill: "#7a1123"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.28,185.74c-.81-.04-1.65-.07-2.41.21-1.31.49-2.12,1.79-2.78,3.03-.51.95-.99,1.93-1.31,2.96-.89,2.97-.32,6.28-1.56,9.12,3.04.34,6.09.69,9.13,1.03,2.02.23,4.04.45,6.07.36.27-.01.58-.06.71-.3.08-.15.05-.32.02-.49-.23-1.4-.54-2.79-.69-4.2-.21-1.95-.12-3.93-.48-5.86-.36-1.93-1.25-3.88-2.92-4.9-1.07-.66-2.35-.87-3.6-.91l-.19-.06Z",
    style: {
      fill: "#ecbb0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.39,204.82c-.1.12-.21.24-.32.35-.07.07-.14.15-.22.22-.11.11-.22.21-.33.32-.03.03-.06.06-.09.09-.12.1-.23.2-.35.3-.13.1-.25.21-.39.3-.02.02-.04.03-.06.04-.09.07-.19.14-.28.2-.02.01-.03.02-.05.03-.08.06-.16.11-.24.16-.53.35-1.1.65-1.69.9-1.05.44-2.19.72-3.38.81h0c-.33.01-.69.02-1.08.03h-.02c-1.23-.03-2.42-.27-3.52-.68-.1-.04-.19-.07-.29-.11-.19-.08-.37-.16-.56-.25-.06-.02-.12-.05-.17-.08-.07-.04-.15-.07-.22-.11,0,0-.02-.01-.03-.02-.09-.05-.19-.1-.28-.15-.4-.22-.78-.47-1.15-.75-.16-.12-.32-.25-.47-.37-.12-.1-.24-.2-.35-.31-.07-.06-.13-.12-.2-.18-.04-.04-.09-.09-.13-.13-.07-.07-.15-.14-.21-.22h0c-.12-.13-.24-.25-.35-.39,0,0,0,0,0-.01l.1-.06c.52-.3,1.02-.61,1.56-.88,1.19-.61,2.48-1.02,3.81-1.23,1.18-.19,2.39-.21,3.58-.06.23.03.47.07.7.11.05,0,.1.02.15.03.05,0,.09.02.14.03.14.03.28.06.42.09.1.02.21.05.31.07.11.03.23.06.34.09.11.03.22.06.34.09.07.02.14.04.21.06,1.16.34,2.3.78,3.45,1.18.45.16.9.31,1.35.46Z",
    style: {
      fill: "#2a59be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.89,199.3v3.34s-.01.04-.05.11c-.08.17-.26.52-.58.84-.37.38-.93.72-1.71.73-1.72.01-2.1-1.57-2.1-1.57.18-.63,0-3.6,0-3.6l4.44.16Z",
    style: {
      fill: "#e4857d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.08,40.47c.44,3.71-1.27,7.3-2.94,10.64-.63,1.26-1.45,2.66-2.64,3.26h0c-.34.17-.7.28-1.1.3-.04,1.78-1.15,3.42-2.62,4.43-1.46,1.01-3.24,1.47-5.01,1.67-.75.09-1.62.19-2.05.81-.41.58-.26,1.38-.49,2.05-.28.8-1.15,1.35-1.99,1.26-.52-.06-.99-.33-1.48-.51-1.06-.38-2.18-.33-3.31-.14-1.81.3-3.66.93-5.42.61-.19-.04-.39-.08-.58-.14l-.03-.31c-1.5-.37-3.07.04-4.61.08-1.54.04-3.33-.47-3.9-1.9-.11-.29-.18-.61-.42-.81-.25-.21-.62-.21-.95-.2-4.46.08-8.91-1.97-11.76-5.4-.62-.75-1.19-1.61-1.26-2.58-.08-.97.5-2.05,1.45-2.24-.13,0-.26-.02-.39-.03-1.11-.1-2.22-.32-3.15-.91-1.04-.66-1.8-1.91-1.56-3.12.11-.54.39-1.03.57-1.55.69-2.02-.32-4.17-.77-6.26-.45-2.09.15-4.89,2.26-5.25-1.16-1.27-.43-3.29.35-4.82.33-.65.66-1.29.98-1.94.4-.79.81-1.58,1.21-2.38.2-.39.4-.78.45-1.21.08-.62-.13-1.25-.03-1.87.28-1.66,2.48-2.08,3.66-3.28.94-.96,1.2-2.38,1.86-3.55.04-.07.09-.15.13-.22,1.5-2.34,5.25-2.77,7.24-.83.29.28.57.62.97.71.54.12,1.04-.25,1.5-.55,1.98-1.26,4.69-1.28,6.69-.04,2.36-.74,4.79-1.23,7.25-1.47,1.54-.15,3.3-.13,4.37,1,.34.36.58.8.97,1.1.36.27.81.38,1.25.48,2.21.5,4.47.75,6.74.76.74,0,1.5-.02,2.17.3,1.62.77,1.78,2.94,2.02,4.72.05.41.15.85.48,1.1.31.23.73.22,1.1.33.96.31,1.36,1.42,1.62,2.4.79,2.94,1.55,5.98,1.15,9-.15,1.11-.45,2.2-.43,3.32.01,1.08.32,2.13.45,3.19Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.5,54.37h0c-.34.17-.7.28-1.1.3-.04,1.78-1.15,3.42-2.62,4.43-1.46,1.01-3.24,1.47-5.01,1.67-.75.09-1.62.19-2.05.81-.41.58-.26,1.38-.49,2.05-.28.8-1.15,1.35-1.99,1.26-.52-.06-.99-.33-1.48-.51-1.06-.38-2.18-.33-3.31-.14-.21-.11-.43-.23-.63-.35-.64-.38-1.31-.82-2.05-.81-1.12.01-1.91.98-2.73,1.77-.19-.04-.39-.08-.58-.14l-.03-.31c-1.5-.37-3.07.04-4.61.08-1.54.04-3.33-.47-3.9-1.9-.11-.29-.18-.61-.42-.81-.25-.21-.62-.21-.95-.2-4.46.08-8.91-1.97-11.76-5.4-.62-.75-1.19-1.61-1.26-2.58-.08-.97.5-2.05,1.45-2.24-.13,0-.26-.02-.39-.03.99-.65,2.36-.76,3.37-.11.71.46,1.35,1.24,2.19,1.13.34-.05.63-.24.94-.38,1.65-.74,3.84.45,4.12,2.23.5-1.36,2.41-1.95,3.59-1.11,0-1.26.99-2.45,2.24-2.67,1.24-.22,2.58.57,3,1.76l.87-.52c.84-1.34,2.73-1.75,4.22-1.22,1.49.53,2.61,1.81,3.37,3.19.61-1.39,2.03-2.39,3.54-2.49,1.51-.1,3.05.69,3.85,1.99.37-.88,1.08-1.74,2.03-1.82.95-.08,1.89,1.1,1.31,1.86,1.31-.99,3.53-.17,3.88,1.43.22-1.35,2.36-1.57,3.22-.5.07.09.14.18.19.28Z",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.63,72.39c-5.64,4.58-12.83,7.33-20.66,7.33-8.31,0-15.89-3.09-21.67-8.19,5.98-2.36,12.03-4.63,18.35-5.72h1.94c1.85.1,2.83.34,4.68.28,2.7-.09,5.88.44,8.19,1.85,1.93,1.18,3.95,2.23,6.03,3.12,1.04.45,2.1.87,3.15,1.32Z",
    style: {
      fill: "#7a1123"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.46,68.84c.92.97,2.3,1.48,3.63,1.33,2.04-.24,3.75-1.89,5.81-1.91,1.54-.01,2.94.91,4.45,1.2-.63-.34-1.26-.68-1.89-1.02-.38-.21-.79-.45-.94-.85-.23-.63.27-1.31.15-1.97-3.74.84-7.43,1.94-11.03,3.27",
    style: {
      fill: "#600c1e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.95,68.79c1.18.14,2.38.09,3.54-.14.69-.13,1.37-.33,2.07-.35.86-.02,1.7.24,2.52.49,2.66.82,5.32,1.63,7.98,2.45-2.42-.86-4.55-2.36-6.82-3.56-2.27-1.2-4.85-2.11-7.38-1.63-.71,1.38-2.04,2.43-3.55,2.8.4.05.81.11,1.21.16",
    style: {
      fill: "#600c1e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.06,60.83l-.8,6.47s.94,1.89,3.1,2.02,4.72-1.89,4.72-1.89v-7.83l-7.02,1.23Z",
    style: {
      fill: "#683914"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.08,61.56s-1.28.69-2.49.69h-4.7l.17-1.41,7.02-1.23v1.95",
    style: {
      fill: "#51290e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.15,221.02c.39-.05.81-.06,1.25-.02.54.04,1.05.12,1.52.23-.91-.17-1.86-.27-2.77-.21Z",
    style: {
      fill: "#e1827c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.72,228.59v6.87c0,.32-.07.63-.22.91-.74,1.46-3.32,6.11-6.6,7.16-.2.07-.41.1-.63.1h-.03c-.47,0-.93-.17-1.29-.47-1.44-1.22-5.15-4.55-5.56-6.98-.38-2.26-.19-6.69-.07-8.78.02-.36.13-.7.33-.99.62-.94,1.64-1.6,2.65-2.16,1.11-.61,2.29-1.16,3.55-1.21,2.12-.08,4.02,1.26,5.65,2.61.6.5,1.19,1.01,1.71,1.58.33.37.52.85.52,1.35Z",
    style: {
      fill: "#e1827c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.72,227.08v.8c-.62-.85-1.42-1.55-2.23-2.22-1.63-1.36-3.53-2.7-5.65-2.61-1.26.05-2.44.6-3.55,1.21-1.19.66-2.41,1.47-2.95,2.71.03-.45.05-.71.05-.71,0,0,1.63-4.73,5.76-5.23.91-.06,1.86.04,2.77.21,3.99.9,5.8,3.83,5.8,5.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.17,253.47c-.31.57-.64,1.13-1,1.67-.75,1.4-1.95,2.72-3.18,3.84-.17.15-.34.3-.5.45-2,1.73-3.91,2.88-3.91,2.88-.02.02-.04.03-.07.05-.66.45-1.38.84-2.14,1.17-1.21.53-2.52.93-3.85,1.2-.01,0-.02,0-.03,0-2.44.5-4.96.62-7.11.52-2.75-.23-5.35-.95-7.73-2.07-1.11-.52-2.17-1.13-3.16-1.82-.79-.54-1.54-1.13-2.25-1.77-.4-.39-.8-.8-1.21-1.21-.5-.49-.97-1.02-1.42-1.57-.08-.09-.15-.19-.22-.28-.29-.36-.56-.74-.82-1.14-.13-.19-.26-.39-.38-.59-.38-.6-.73-1.22-1.06-1.85,1.86-1.2,3.77-2.31,5.73-3.32h0c.12-.06.23-.12.35-.18l.39-.09c3.74,1.8,7.2,4.28,11.22,5.33,5.85,1.53,12.48-.4,16.59-4.84.02-.02.04-.04.06-.06,1.9,1.23,3.8,2.46,5.71,3.69Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.65,263.18c-1.11-.52-2.17-1.13-3.16-1.82-1.2-.87-2.37-1.89-3.46-2.98h0c1.85-.16,3.66-.82,5.17-1.9.08-.06.17-.12.26-.09.11.03.14.17.16.28.34,2.08.68,4.42,1.02,6.51Z",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.56,259.31s-.04.08-.07.12c-2,1.73-3.91,2.88-3.91,2.88-.02.02-.04.03-.07.05-.66.45-1.38.84-2.14,1.17.08-.82.45-1.69,1.19-2.06.35-.17.74-.22,1.12-.32,1.39-.37,2.49-1.46,3.88-1.84Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.87,44.13s-1.08-7.68,7.41-8.49,10.38,3.91,10.91,7.41,1.08,8.62-1.75,12.26c-2.83,3.64-3.77,5.39-5.52,5.52-1.75.13-3.53.27-4.86,0s-5.92-6.33-6.05-9.7-.13-7.01-.13-7.01Z",
    style: {
      fill: "#683914"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.79,188.88l-.04-.03c.06.02.13.05.19.08-.05-.01-.1-.03-.15-.04Z",
    style: {
      fill: "#e4857d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.86,191.73v4.22s-1.11,3.42-3.02,3.97c-1.91.55-3.51-.8-3.88-1.23s-1.66-2.59-1.72-5.3c0,0,.04-1.67.68-3.05-.03.13-.07.25-.1.38.57-.65,1.19-1.33,2-1.61.48-.17,1-.19,1.51-.2.91-.02,1.82,0,2.72.06.93.44,1.57,1.27,1.81,2.76Z",
    style: {
      fill: "#e4857d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.24,193.4s-.08-.18-.41,0-.28,1.78,0,2.25.87.46.87.46c0,0-.52-2.09-.46-2.71Z",
    style: {
      fill: "#e4857d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.7,193.36s.86-.43.99.18.34,1.43-.09,1.71-.74.69-.74.69l-.15-2.59Z",
    style: {
      fill: "#e4857d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.49,199.9s1.54,1.04,2.46.98,1.94-1.17,1.94-1.17v-.41s-.45.93-1.84.79-2.6-.95-2.6-.95l.04.76Z",
    style: {
      fill: "#af5f5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.42,202.63s0,.02-.01.02c-.55,1.02-1.54,1.77-2.64,2.17-.79.29-1.62.4-2.46.4h0c-.12-.13-.24-.25-.35-.39.03-.02.06-.05.09-.07,1.56-1.18,3.44-1.93,5.38-2.14Z",
    style: {
      fill: "#2252a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.71,203.52c.35.48.87.83,1.44.96s1.2.06,1.72-.21c-.75-.01-1.48-.38-1.93-.98-.17-.23-.31-.48-.5-.69-.25.22-.46.48-.62.77",
    style: {
      fill: "#2252a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.39,204.82c-.17.2-.35.39-.54.58-.72-.13-1.43-.36-2.17-.8-.48-.29-.94-.62-1.46-.8-.95-.33-1.98-.1-2.97-.21.32-.32.5-.67.58-.84h0s.09.02.14.03c.14.03.28.06.42.09.1.02.21.05.31.07.11.03.23.06.34.09.11.03.22.06.34.09.07.02.14.04.21.06,1.16.34,2.3.78,3.45,1.18.48.2.93.34,1.35.46Z",
    style: {
      fill: "#2252a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.05,188.97c-.91-.06-1.82-.08-2.72-.06-.51,0-1.03.03-1.51.2-.82.29-1.43.96-2,1.61.04-.13.07-.25.1-.38.44-.95,1.16-1.77,2.34-1.82,1.35-.06,2.55-.03,3.49.32l.04.03s.1.03.15.04c.04.02.07.03.11.05Z",
    style: {
      fill: "#e4857d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.45,188.61l.3.23c-.95-.35-2.15-.37-3.49-.32-1.18.05-1.9.87-2.34,1.82.14-.57.22-1.16.25-1.75-.16.1-.33.21-.49.31.14-.3.22-.62.23-.95-.68.21-.99.96-1.34,1.58-.36.64-.84,1.2-1.42,1.65l.73-1.77c.47-1.14.99-2.35,2.02-3.03,1.13-.75,2.59-.69,3.95-.59-.38.31-.76.61-1.14.92-.09.07-.18.15-.22.26-.03.11.03.25.14.26-.23.17-.42.4-.55.65,1.09.39,2.23.63,3.39.72Z",
    style: {
      fill: "#d8a709"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.13,188.98s-.05,0-.08,0c-.04-.02-.07-.03-.11-.05.06.02.12.04.19.05Z",
    style: {
      fill: "#d8a709"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10-2",
    "data-name": "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m282.79,159.84h-5.91v-25.4h-8.86v-5.91h23.62v5.91h-8.86v25.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m306.79,142.67c-4.17,0-6.28,2.83-6.28,7.09v10.08h-5.91v-23.03h4.19l.63,5.5c1.66-3.14,8.89-4.91,8.89-4.91h1.06v5.32h-2.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "m336.37,157.03c0,6.55-4.26,11.45-11.22,11.45-4.13,0-7.54-1.48-9.97-3.5l3.23-3.46c2.15,1.08,4.17,1.8,6.73,1.75,3.23,0,5.48-1.66,5.48-4.94v-1.5c-1.43,1.84-3.81,2.65-6.14,2.65-6.5,0-9.81-4.45-9.81-10.95v-11.13h5.91v10.82c0,4.13,1.92,5.75,4.89,5.75,3.14,0,5.15-1.93,5.15-6.24v-10.32h5.91v19.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m289.28,200v-12.99h-12.4v12.99h-5.91v-31.89h5.91v12.99h12.4v-12.4h5.91v31.3h-5.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "m319.12,188.68c0-3.68-2.83-6.01-5.79-6.01s-5.79,2.33-5.79,6.01,2.78,5.97,5.79,5.97,5.79-2.29,5.79-5.97Zm1.19,11.32l-.31-3.19c-1.98,2.52-5.44,3.95-9.3,3.3-5.07-.85-8.72-5.29-9.07-10.42-.46-6.79,4.24-12.45,10.92-12.45,3.1,0,5.79,1.39,7.45,3.5l.31-3.19h3.82v22.44h-3.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "m351.04,181.32l-3.41,3.68c-1.84-1.71-3.46-2.29-5.43-2.29-3.01,0-5.79,2.29-5.79,5.97s2.78,5.97,5.79,5.97c1.97,0,3.59-.58,5.43-2.29l3.41,3.68c-2.11,2.51-5.3,4.13-8.84,4.13-6.38,0-11.49-5.12-11.49-11.49s5.12-11.49,11.49-11.49c3.55,0,6.73,1.62,8.84,4.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m368.9,193.97c-1.35-2.06-2.11-2.83-4.26-2.83h-1.53v8.86h-5.91v-31.3h5.91v17.13h1.41c2.14,0,2.91-.73,4.27-2.86l3.54-5.41h6.18l-5.03,7.58c-.94,1.48-2.2,2.87-3.18,3.28,1.12.36,2.38,1.8,3.41,3.37l5.38,8.22h-6.33l-3.86-5.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "m295.19,236.03v-20.07l-9.47,11.76-9.43-11.76v20.07h-5.91v-31.3h3.68l11.95,14.94,11.99-14.94h3.68v31.3h-6.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "m314.86,222.45h10.28c0-.54-.18-1.26-.54-1.8-.76-1.44-2.38-2.51-4.53-2.51-3.05,0-5.12,2.15-5.21,4.31Zm15.08-2.91c.94,2.06.99,5.12.36,7.05h-15.67c0,3.05,2.51,4.72,5.56,4.72,2.33,0,4.76-.54,6.78-1.57l3.01,3.28c-2.42,1.8-5.79,3.5-9.79,3.5-6.82,0-11.45-4.94-11.45-11.49s4.31-11.54,11.31-11.54c4.8,0,8.17,2.29,9.87,6.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "m197.15,166.34v-10.84l-2.8,2.12-1.85-2.48,4.94-3.57h3.25v14.76h-3.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m211.1,158.8c0-.45-.03-.95-.08-1.5-.06-.54-.16-1.06-.31-1.53-.15-.47-.37-.87-.65-1.19-.28-.32-.64-.48-1.1-.48s-.82.16-1.1.48c-.29.32-.51.72-.67,1.19-.16.47-.26.98-.32,1.53-.06.55-.08,1.05-.08,1.5s.03.97.08,1.53c.06.55.16,1.06.32,1.53.16.47.38.87.67,1.19.29.32.66.48,1.1.48s.82-.16,1.1-.48c.28-.32.5-.72.65-1.19.15-.47.25-.98.31-1.53.05-.55.08-1.06.08-1.53Zm3.52,0c0,1.02-.1,2-.31,2.93-.2.93-.53,1.74-.98,2.45-.45.7-1.03,1.26-1.75,1.68-.72.41-1.59.62-2.61.62s-1.9-.21-2.62-.62c-.72-.42-1.31-.98-1.77-1.68-.46-.7-.79-1.52-.99-2.45-.2-.93-.3-1.9-.3-2.93s.1-2,.3-2.92c.21-.92.54-1.73.99-2.42.46-.69,1.05-1.24,1.77-1.65.72-.41,1.6-.61,2.62-.61s1.9.2,2.61.61c.72.41,1.3.96,1.75,1.65.45.69.78,1.5.98,2.42.21.92.31,1.89.31,2.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "m233.77,166.34v-10.84l-2.8,2.12-1.85-2.48,4.94-3.57h3.25v14.76h-3.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "m247.88,158.8c0-.45-.03-.95-.08-1.5-.06-.54-.16-1.06-.31-1.53-.15-.47-.37-.87-.65-1.19-.28-.32-.65-.48-1.1-.48s-.82.16-1.1.48c-.29.32-.51.72-.67,1.19-.16.47-.26.98-.32,1.53-.06.55-.08,1.05-.08,1.5s.03.97.08,1.53c.06.55.16,1.06.32,1.53.16.47.38.87.67,1.19.29.32.66.48,1.1.48s.82-.16,1.1-.48c.28-.32.5-.72.65-1.19.15-.47.25-.98.31-1.53.05-.55.08-1.06.08-1.53Zm3.52,0c0,1.02-.1,2-.31,2.93-.2.93-.53,1.74-.98,2.45-.45.7-1.03,1.26-1.75,1.68-.72.41-1.59.62-2.61.62s-1.9-.21-2.62-.62c-.72-.42-1.31-.98-1.77-1.68-.46-.7-.79-1.52-.99-2.45-.2-.93-.3-1.9-.3-2.93s.1-2,.3-2.92c.21-.92.54-1.73.99-2.42s1.05-1.24,1.77-1.65c.72-.41,1.6-.61,2.62-.61s1.89.2,2.61.61c.72.41,1.3.96,1.75,1.65.45.69.78,1.5.98,2.42.21.92.31,1.89.31,2.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m196.56,188.78v-10.84l-2.8,2.13-1.85-2.48,4.94-3.57h3.25v14.76h-3.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "m208.96,188.78v-10.84l-2.8,2.13-1.85-2.48,4.94-3.57h3.25v14.76h-3.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "m220.77,188.78v-10.84l-2.8,2.13-1.84-2.48,4.94-3.57h3.25v14.76h-3.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "m235.45,181.62c0-.45-.03-.95-.08-1.49-.05-.55-.16-1.06-.3-1.53-.15-.47-.37-.87-.65-1.19-.28-.32-.65-.48-1.1-.48s-.82.16-1.11.48c-.29.32-.51.72-.66,1.19-.16.47-.26.98-.32,1.53-.06.54-.08,1.04-.08,1.49s.03.97.08,1.53c.06.55.16,1.06.32,1.53.16.47.38.87.66,1.19.29.32.66.48,1.11.48s.82-.16,1.1-.48c.28-.32.5-.72.65-1.19.15-.47.25-.98.3-1.53.06-.55.08-1.06.08-1.53Zm3.52,0c0,1.02-.1,2-.31,2.93-.21.93-.53,1.74-.98,2.45-.45.7-1.03,1.26-1.75,1.68-.72.42-1.58.62-2.61.62s-1.9-.21-2.62-.62c-.72-.41-1.31-.97-1.77-1.68-.46-.7-.79-1.52-.99-2.45-.2-.93-.31-1.9-.31-2.93s.1-2,.31-2.92c.21-.92.54-1.73.99-2.41.46-.69,1.05-1.24,1.77-1.65.72-.41,1.6-.61,2.62-.61s1.89.21,2.61.61c.72.41,1.3.96,1.75,1.65.45.69.78,1.49.98,2.41.21.92.31,1.89.31,2.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "m203.65,205.32v-7.81l-1.87,1.53-1.23-1.78,3.3-2.57h2.16v10.63h-2.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "m221.37,205.32v-7.81l-1.87,1.53-1.23-1.78,3.3-2.57h2.17v10.63h-2.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "m196.71,199.87c0-.33-.02-.69-.06-1.09-.04-.39-.11-.76-.22-1.11-.11-.34-.26-.63-.47-.86-.2-.23-.47-.35-.79-.35s-.6.12-.8.35c-.21.23-.37.52-.48.86-.12.34-.19.71-.23,1.11-.04.4-.06.76-.06,1.09s.02.71.06,1.11c.04.4.11.78.23,1.12.11.34.27.63.48.86.21.23.47.35.8.35s.59-.11.79-.35c.2-.23.36-.52.47-.86.11-.34.18-.72.22-1.12.04-.4.06-.77.06-1.11Zm2.56,0c0,.74-.07,1.45-.22,2.13-.15.67-.39,1.27-.71,1.77-.33.51-.75.92-1.27,1.22-.52.3-1.15.45-1.89.45s-1.38-.15-1.9-.45c-.53-.3-.95-.71-1.29-1.22-.33-.51-.57-1.1-.72-1.77-.15-.67-.22-1.38-.22-2.13s.07-1.45.22-2.12c.15-.67.39-1.25.72-1.76.33-.5.76-.9,1.29-1.2.53-.3,1.16-.45,1.9-.45s1.37.15,1.89.45c.52.3.94.7,1.27,1.2.33.5.57,1.09.71,1.76.15.67.22,1.38.22,2.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "m214.21,199.87c0-.33-.02-.69-.06-1.09-.04-.39-.11-.76-.22-1.11-.11-.34-.26-.63-.47-.86-.2-.23-.47-.35-.79-.35s-.6.12-.8.35c-.21.23-.37.52-.48.86-.12.34-.19.71-.23,1.11-.04.4-.06.76-.06,1.09s.02.71.06,1.11c.04.4.11.78.23,1.12.11.34.27.63.48.86.21.23.47.35.8.35s.59-.11.79-.35c.2-.23.36-.52.47-.86.11-.34.19-.72.22-1.12.04-.4.06-.77.06-1.11Zm2.56,0c0,.74-.07,1.45-.22,2.13-.15.67-.39,1.27-.71,1.77-.33.51-.75.92-1.27,1.22-.52.3-1.15.45-1.89.45s-1.38-.15-1.9-.45c-.53-.3-.95-.71-1.29-1.22-.33-.51-.57-1.1-.72-1.77-.15-.67-.22-1.38-.22-2.13s.07-1.45.22-2.12c.15-.67.39-1.25.72-1.76.33-.5.76-.9,1.29-1.2.53-.3,1.16-.45,1.9-.45s1.37.15,1.89.45c.52.3.94.7,1.27,1.2.33.5.56,1.09.71,1.76.15.67.22,1.38.22,2.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "m250.3,205.32v-7.81l-1.87,1.53-1.23-1.78,3.3-2.57h2.17v10.63h-2.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "m243.17,199.87c0-.33-.02-.69-.06-1.09-.04-.39-.11-.76-.23-1.11-.11-.34-.26-.63-.47-.86-.2-.23-.47-.35-.79-.35s-.6.12-.8.35c-.21.23-.37.52-.49.86-.11.34-.19.71-.23,1.11-.04.4-.06.76-.06,1.09s.02.71.06,1.11c.04.4.12.78.23,1.12.12.34.28.63.49.86.21.23.47.35.8.35s.59-.11.79-.35c.2-.23.36-.52.47-.86.11-.34.19-.72.23-1.12.04-.4.06-.77.06-1.11Zm2.56,0c0,.74-.07,1.45-.22,2.13-.15.67-.39,1.27-.71,1.77-.33.51-.75.92-1.27,1.22-.52.3-1.15.45-1.89.45s-1.38-.15-1.9-.45c-.53-.3-.95-.71-1.29-1.22-.33-.51-.57-1.1-.72-1.77-.15-.67-.22-1.38-.22-2.13s.07-1.45.22-2.12c.15-.67.39-1.25.72-1.76.33-.5.76-.9,1.29-1.2.53-.3,1.16-.45,1.9-.45s1.37.15,1.89.45c.52.3.94.7,1.27,1.2.33.5.56,1.09.71,1.76.15.67.22,1.38.22,2.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "m240.26,217.72v-7.81l-1.87,1.53-1.23-1.79,3.3-2.57h2.17v10.63h-2.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "m233.62,212.27c0-.33-.02-.69-.06-1.09-.04-.39-.11-.76-.22-1.11-.11-.34-.26-.63-.47-.86-.2-.23-.47-.35-.79-.35s-.6.12-.8.35c-.21.23-.37.52-.48.86-.11.34-.19.71-.23,1.11-.04.4-.06.76-.06,1.09s.02.71.06,1.11c.04.4.12.78.23,1.12.11.34.27.63.48.86.21.23.47.35.8.35s.59-.11.79-.35c.2-.23.36-.52.47-.86.11-.34.18-.72.22-1.12.04-.4.06-.77.06-1.11Zm2.56,0c0,.74-.07,1.45-.22,2.13-.15.67-.39,1.27-.71,1.78-.33.51-.75.92-1.27,1.22-.52.3-1.15.45-1.89.45s-1.38-.15-1.9-.45c-.53-.3-.95-.71-1.29-1.22-.33-.51-.57-1.1-.72-1.78-.15-.67-.22-1.38-.22-2.13s.08-1.45.22-2.12c.15-.67.39-1.26.72-1.76.33-.5.76-.9,1.29-1.2.53-.3,1.16-.45,1.9-.45s1.37.15,1.89.45c.52.3.94.7,1.27,1.2.33.5.57,1.09.71,1.76.15.67.22,1.37.22,2.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "m200.1,217.13v-5.2l-1.4,1.02-.92-1.19,2.47-1.71h1.62v7.09h-1.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "m195.44,213.74c0-.23-.02-.48-.04-.75-.03-.27-.08-.53-.16-.77-.07-.24-.18-.44-.32-.6-.14-.16-.33-.24-.55-.24s-.41.08-.56.24c-.14.16-.26.36-.34.6-.08.24-.13.49-.16.77-.03.28-.04.53-.04.75s.01.49.04.77c.03.28.08.54.16.77.08.24.19.44.34.6.14.16.33.24.56.24s.41-.08.55-.24c.14-.16.25-.36.32-.6.08-.24.13-.49.16-.77.02-.28.04-.54.04-.77Zm1.77,0c0,.51-.05,1.01-.15,1.47-.1.46-.27.88-.5,1.23-.23.35-.52.63-.88.84-.36.21-.8.32-1.31.32s-.96-.11-1.32-.32c-.36-.21-.66-.49-.89-.84-.23-.35-.4-.77-.5-1.23-.1-.47-.15-.96-.15-1.47s.05-1.01.15-1.47c.1-.46.27-.87.5-1.22.23-.34.53-.62.89-.83.36-.21.8-.31,1.32-.31s.95.1,1.31.31c.36.2.66.48.88.83.23.35.39.75.5,1.22.1.46.15.95.15,1.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "m221.37,226.58v-5.2l-1.4,1.02-.92-1.19,2.47-1.71h1.62v7.09h-1.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "m216.85,223.11c0-.23-.01-.48-.04-.75-.03-.27-.08-.53-.15-.77s-.18-.44-.32-.6c-.14-.16-.33-.24-.55-.24s-.41.08-.55.24c-.14.16-.26.36-.34.6-.08.24-.13.49-.16.77-.03.28-.04.53-.04.75s.02.49.04.77c.03.28.08.54.16.78.08.24.19.43.34.6.14.16.33.24.55.24s.41-.08.55-.24c.14-.16.25-.36.32-.6.08-.24.13-.5.15-.78.03-.28.04-.53.04-.77Zm1.77,0c0,.51-.05,1.01-.16,1.47-.1.47-.27.88-.49,1.23-.23.35-.52.64-.88.85-.36.21-.8.31-1.31.31s-.95-.1-1.32-.31c-.37-.21-.66-.49-.89-.85-.23-.35-.4-.76-.5-1.23-.1-.47-.16-.96-.16-1.47s.05-1.01.16-1.47c.1-.46.27-.87.5-1.22.23-.35.53-.62.89-.83.36-.21.8-.31,1.32-.31s.95.1,1.31.31c.36.21.66.48.88.83.22.34.39.75.49,1.22.1.46.16.95.16,1.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "m250.99,212.27c0-.33-.02-.69-.06-1.09-.04-.39-.11-.76-.22-1.11-.11-.34-.26-.63-.47-.86-.2-.23-.47-.35-.79-.35s-.6.12-.8.35c-.21.23-.37.52-.48.86-.11.34-.19.71-.23,1.11-.04.4-.06.76-.06,1.09s.02.71.06,1.11c.04.4.12.78.23,1.12.11.34.27.63.48.86.21.23.48.35.8.35s.59-.11.79-.35c.2-.23.36-.52.47-.86.11-.34.19-.72.22-1.12.04-.4.06-.77.06-1.11Zm2.56,0c0,.74-.08,1.45-.23,2.13-.15.67-.39,1.27-.71,1.78-.33.51-.75.92-1.27,1.22-.52.3-1.15.45-1.89.45s-1.38-.15-1.9-.45c-.52-.3-.95-.71-1.29-1.22-.33-.51-.57-1.1-.72-1.78-.15-.67-.22-1.38-.22-2.13s.08-1.45.22-2.12c.15-.67.39-1.26.72-1.76.33-.5.76-.9,1.29-1.2.53-.3,1.16-.45,1.9-.45s1.37.15,1.89.45c.52.3.94.7,1.27,1.2.33.5.57,1.09.71,1.76.15.67.23,1.37.23,2.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "m246.2,141.45c-2.43-11.86-12.99-20.46-25.11-20.46-1.85,0-3.66.21-5.43.59-2.95-17.28-18.02-30.49-36.13-30.49s-32.9,12.96-36.05,30.01c-18.45,1.68-31.32,22.99-17.45,42.83,3.69,5.27,9.8,8.31,16.23,8.31h43.4c.13,0,.27-.05.37-.14,3.34-3.1,1.19-6.95-1.86-6.95h-37.93c-10.1,0-18.67-7.91-18.95-18.01-.29-10.47,8.13-19.07,18.53-19.07,3.72,0,7.3,1.09,10.36,3.16,1.62,1.09,3.83.67,4.92-.95,1.1-1.62.67-3.83-.95-4.92-2.89-1.96-6.13-3.26-9.52-3.91,2.89-13.29,14.75-23.28,28.89-23.28,15.07,0,27.54,11.33,29.34,25.92-.95.52-1.88,1.08-2.77,1.73-1.59,1.14-1.94,3.36-.8,4.95,1.15,1.59,3.36,1.94,4.95.8,3.17-2.29,6.92-3.5,10.84-3.5,8.77,0,16.41,6.22,18.16,14.8.34,1.68,1.82,2.83,3.47,2.83.23,0,.47-.02.71-.07,1.92-.39,3.15-2.26,2.76-4.18",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityDarkMode);
export default __webpack_public_path__ + "static/media/community-dark-mode.60f1efdccfd255778b64789508e3ccc0.svg";
export { ForwardRef as ReactComponent };